import { AuthUser } from '~/auth/user.ts';

export function identify(user: AuthUser, authenticated: boolean = false) {
    const data = userData(user);

    if (window.chmln?.identify) {
        window.chmln.identify(user.id, data);
    }

    if (window.gtag) {
        window.gtag('config', 'G-NQXFDVY46S', {
            user_id: user.id,
        });
        window.gtag('config', 'AW-492040388', {
            user_id: user.id,
        });
    }

    if (window.heap) {
        window.heap.identify(`${user.id}`);
        window.heap.addUserProperties(data);
    }

    if (authenticated) {
        track('login', data);
    }
}

function userData(user: AuthUser): Record<string, any> {
    if (!user.authenticated) return {};

    const name = `${user.first_name} ${user.last_name}`.trim();
    let role = '';
    if (user.isRemotely()) {
        role = 'remotely';
    } else if (user.isContractor()) {
        role = 'contractor';
    } else if (user.isInterviewer()) {
        role = 'interviewer';
    } else if (user.isCustomer()) {
        role = 'customer';
    } else if (user.isCandidate()) {
        role = 'candidate';
    } else if (user.isApplicant()) {
        role = 'applicant';
    }

    return {
        email: user.email,
        name: name,
        role,
        country: user.country,
        contractor_status: user.contract?.status,
        customer_name: user.company,
        linkedin_url: user.linkedin_url,
        github_url: user.github_url,
        method: 'email',
    };
}

export function trackUser(event: string, user: AuthUser, data: Record<string, any> = {}) {
    track(event, { ...userData(user), ...data });
}

export function track(event: string, data: Record<string, any> = {}) {
    if (window.gtag) {
        window.gtag('event', event, data);
    }

    if (window.heap) {
        window.heap.track(event, data);
    }
}

export function trackLinkedInDeveloperConversion() {
    if (window.lintrk) {
        window.lintrk('track', { conversion_id: 15045297 });
        window.lintrk('track', { conversion_id: 13977010 });
    }

    if (window.fbq) {
        window.fbq('track', 'SubmitApplication');
    }
}

export function trackStartupConversion() {
    if (window.lintrk) {
        window.lintrk('track', { conversion_id: 13631092 });
        window.lintrk('track', { conversion_id: 13977058 });
    }

    if (window.fbq) {
        window.fbq('track', 'SubmitApplication');
    }
}

export function trackFormSubmit(id: string, name?: string) {
    track('form_submit', {
        form_id: id,
        form_name: name,
        form_destination: window.location.toString(),
        form_origin: window.location.toString(),
    });
}
